import { StatusCodes } from "http-status-codes";
import moment from "moment";
import { toast } from "react-toastify";
import DummyImg from "../../../src/assets/image/auth-one-bg.jpg";

export const dateFormat = (date) => {
  return moment(date).format("DD-MM-YYYY");
};

export const getFormData = (object) => {
  const formData = new FormData(object);
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

export const dateFormatChange = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
export const timeFormat = (date) => {
  return moment(date).format("H:mm");
};

export const dateMonthFormat = (date) => {
  return moment(date).format("DD MMM Y");
};

export const DummyImage = DummyImg;
export const ErrorImage = "https://www.pngall.com/wp-content/uploads/5/Profile-PNG-File.png";

export const RequiredSign = "*";

export const CommonLabel = {
  Submit: "Submit",
  Delete: "Delete",
  Update: "Update",
  Cancel: "Cancel",
  Loading: "Loading",
  Search: "Search",
  Close: "Close",
  Discard: "Discard",
  Success: "Success",
  Clear: "Clear",
  Filter: "Filter",
  Yes: "Yes",
  No: "No",
  Save: "Save",
  View: "View",
  Register: "Register",
  Back: "Back",
  Add: "Add",
  Approve: "Approve",
  Reject: "Reject",
  Pending: "Pending",
  Action: "Action",
  SrNo: "Sr.no",
  Status: "Status",
  InvalidDate: "Invalid date",
  PDFFileMessage: "File must be PDF only",
  LogOutMessage: "Are you sure you want to log out?",
  RecordConfirmation: "Do you really want to perform this action?",
  BasicConfirmation: "Are you sure?",
};

export const ResponseType = {
  Pdf: "application/pdf",
};
export const HandleResponse = {
  NoDataFound: "Sorry! No Result Found",
  NoData: "--",
};
export const checkStatusCodeSuccess = (data) => {
  return [StatusCodes.OK, StatusCodes.ACCEPTED, StatusCodes.CREATED].includes(
    data
  );
};

export const errorHandler = (err) => {
  if (Array.isArray(err?.response?.data?.message)) {
    err?.response?.data?.message?.map((message) => {
      toast.error(message);
    });
  } else {
    toast.error(err?.response?.data?.message || err?.message);
  }
};

export function GET_LABEL(fieldName) {
  return capitalize(fieldName);
}

export function getInputPlaceholder(fieldName) {
  return `Enter ${capitalize(fieldName)}`;
}

export function getSelectPlaceholder(fieldName) {
  return `Select ${capitalize(fieldName)}`;
}

function capitalize(text) {
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

export const getStatusBadgeClass = (status) => {
  switch (status) {
    case "Pending":
      return "warning";
    case "Rejected":
      return "danger";
    case "Approved":
      return "success";
    default:
      return "info";
  }
};

export const Roles = {
  Employee: "Employee",
  HR: "HR",
  BDE: "BDE",
  Admin:"Admin",
};

export const DocPDFNote = (fileName) => {
  return `Note: Upload Front and back side of ${fileName} in a single file (PDF Only)`;
}

export const onError = (e, isProfile=false) => {
  const target = e.target;
  target.onerror = null; 
  target.src = isProfile ? ErrorImage : DummyImage;
};

export const RupeeSymbol = (value) => {
  return `₹ ${value}`;
};
export const GBSuffix = (value) => {
  return `${value} GB`;
}
export const MenuItems = {
  Dashboard: "Dashboard",
  Employees: "Employees",
  Review: "Review",
  ITP: "ITP",
  Leaves: "Leaves",
  Support: "Support",
  Report: "Report",
  BDE: "BDE",
  Interview: "Interview",
  ProjectManagement: "Project Management",
  Company: "Company",
  Project: "Project",
  Payment: "Payment",
  AliasUser: "Alias User",
  DailyUpdate: "Daily Update",
  Timesheet: "Timesheet",
  Tasksheet: "Tasksheet",
  Review: "Review",
  Recruitment: "Recruitment",
  ResourcesManagement: "Resources Management",
  Configuration: "Resources",
  Allocation: "Allocation",
  DamagedResources: "Damaged Resources",
  Employee: "Employee",
  ITP: "ITP",
  Leave: "Leave",
  HRLeave: "HR Leave",
  CompoffLeave: "Compoff Leave",
  EmployeeLeave: "Employee Leave",
  Support: "Support",
  HRSupport: "HR Support",
  EmployeeSupport: "Employee Support",
  ResetPassword: "Reset Password",
  DailyUpdate: "Daily Update",
  Interview: "Interview",
  BDE: "BDE",
  Resource: "Resource",
  Course: "Course",
};

export const TableSortFunction = (rowA, rowB, accessor) => {
  const getValue = (row) => {
    if (typeof accessor === "function") {
      return accessor(row) || "";
    }

    return (
      accessor
        .split(".")
        .reduce((acc, key) => acc?.[key], row?.original)
        ?.toString()
        .toLowerCase() || ""
    );
  };

  return getValue(rowA).localeCompare(getValue(rowB));
};



export const SerialNoCol = () => ({
  Header: CommonLabel.SrNo,
  Cell: ({ row }) => <div>{row.index + 1}</div>,
});